<div class="flex w-full items-center justify-between py-2 px-4 text-base leading-6">
  <div class="flex flex-col flex-1">
    <div class="flex items-center gap-3">
      <span class="font-mono text-gray-700">
        {{timeEntry().startDateTime ? (timeEntry().startDateTime | date: 'HH:mm') : '00:00'}} –
        {{timeEntry().endDateTime ? (timeEntry().endDateTime | date: 'HH:mm') : '00:00'}}
      </span>
      <span class="text-gray-500">
        {{timeEntry().startDateTime ? (timeEntry().startDateTime | date: 'dd.M.yyyy') : ''}}
      </span>
      <span class="text-gray-500">
        {{timeEntry().user?.firstName || ''}} {{timeEntry().user?.lastName || ''}}
      </span>
    </div>
    <div class="flex items-center">
      @if (timeEntry().pauseDuration && timeEntry().pauseDuration > 0) {
        <span class="inline-flex items-center px-2 py-1 mt-[2px] rounded bg-yellow-100 text-yellow-800 mr-2 text-[11px] leading-[11px]">
          <i class="icon-pause mr-1"></i>
          Pause: {{formatPauseDuration(timeEntry().pauseDuration)}}
        </span>
      }
      <app-activity-owner-badge
        [owner]="timeEntry().owner"
        [ownerId]="ownerId()">
      </app-activity-owner-badge>
    </div>
  </div>

  <div class="text-gray-900 font-medium ml-4">
    {{formatDurationToStd(timeEntry().duration || 0)}}
  </div>
</div>
